import MaterialTable from "@material-table/core";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { internalQuoteOrders } from "../../api";
import LoaderComponent from "../../../LoaderComponent/LoaderComponent";
import { log } from "../../../Helper";
import InternalQuoteDialog from "../Dialog/InternalQuoteDialog";
import { validateProvider, validateSelection } from "../validation";
import { validationStatus } from "../../utility/constants";
import MatTableHeader from "../../IntMaterialTableHeader/IntMaterialTableHeader";
import { Button } from "@deere/fuel-react";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../../load-build/utility/constants";
import { useUserInfo } from "../../../common/user-context";
import useFilterState from "../../../hooks/useFilterState";
import _ from "lodash";

const OrdersMaterialTable = ({ tableName }) => {
  const { userData } = useUserInfo();
  const authorities = userData.authorities;
  const [tableData, setTableData] = useState(Array(0));
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(5000);
  const [pageNumber, setPageNumber] = useState(0);
  const [selectOrders, setSelectOrders] = useState(false);
  const [selectedMachinesForQuote, setselectedMachinesForQuote] = useState([]);
  const [preSelectedProvider, setPreSelectedProvider] = useState();

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setPreSelectedProvider();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const getTableData = async () => {
    setIsLoading(true);
    try {
      const response = await internalQuoteOrders(pageNumber, pageSize);
      setTableData(response);
    } catch (error) {
      log("Error occured when fetching active quotes: ", error);
      setTableData(Array(0));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (authorities && authorities.includes("ROLE_FULL_APPLICATION_ACCESS")) {
      setSelectOrders(true);
    } else if (
      authorities &&
      authorities.includes("ROLE_READ_APPLICATION_ACCESS")
    ) {
      setSelectOrders(false);
    }
  }, [userData]);

  useEffect(() => {
    getTableData();
  }, []);

  const columns = [
    {
      title: "OrderPath Id",
      field: "orderPathId",
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Comar",
      field: "comar",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Order Number",
      field: "orderNumber",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Order Number",
      field: "orderNumber",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Order Year",
      field: "orderYear",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "From Location",
      field: "fromLocation",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "To Location",
      field: "toLocation",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Model",
      field: "product",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Serial No",
      field: "serial",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Providers",
      field: "providerList",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
        minWidth: "300px",
      },
      cellStyle: {
        minWidth: "300px",
      },
    },
    {
      title: "Status",
      field: "status",
      sorting: true,
      cellStyle: {
        width: 15,
        maxWidth: 15,
        textAlign: "left",
      },
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "ETA",
      field: "eta",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "",
      field: "fullProviderList",
      hidden: true,
    },
  ];

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  const [selectedRowIds, setSelectedRowIds] = useState(new Set());

  return (
    <ThemeProvider theme={theme}>
      {isLoading && <LoaderComponent />}
      {!isLoading && (
        <div className="flex flex-col mt-[-2rem]">
          <MatTableHeader getTableData={getTableData} />
          <MaterialTable
            columns={columnsWithFilter.map((col, index) => {
              if (
                col.tableData?.filterValue == "" ||
                col.tableData?.filterValue == null ||
                col.tableData?.filterValue == undefined
              ) {
                let colWithoutDefaultFilter = _.omit(
                  col,
                  "defaultFilter",
                  "tableData.filterValue"
                );
                return colWithoutDefaultFilter;
              } else {
                return {
                  ...col,
                  defaultFilter: col.tableData?.filterValue,
                };
              }
            })}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h6 className="left-[45%] absolute top-[40%] text-center">
                    No records to display
                  </h6>
                ),
              },
              pagination: {
                labelRowsPerPage: "Orders Per Page",
                labelRowsSelect: "Orders",
              },
            }}
            options={{
              rowStyle: {
                fontSize: 10,
                height: selectOrders ? 10 : 50,
              },
              draggable: false,
              selection: selectOrders,
              search: false,
              showTitle: false,
              grouping: false,
              pageSize: 100,
              filtering: true,
              maxBodyHeight: 600,
              headerStyle: {
                backgroundColor: "#367c2b",
                fontWeight: "400",
                color: "white",
                position: "sticky",
                top: 0,
                zIndex: 10,
              },
              tableContainerStyle: {
                maxHeight: 600,
                overflow: "auto",
              },
              pageSizeOptions: [100, 500, 1000],
              filterCellStyle: {
                flex: 1,
              },
            }}
            title={"Quote Results"}
            onSelectionChange={(selectedRows) => {
              const newSelectedIds = new Set(
                selectedRows.map((row) => row.orderPathId)
              );
              setSelectedRowIds(newSelectedIds);
            }}
            data={tableData.map((row) => ({
              ...row,
              tableData: {
                ...(row.tableData || {}),
                checked: selectedRowIds.has(row.orderPathId),
              },
            }))}
            onFilterChange={(filters) => {
              // Create a map of current filters for quick lookup
              const filterMap = new Map();
              filters.forEach((filter) => {
                filterMap.set(filter.column.tableData.id, filter.value);
              });

              // Iterate over all columns to ensure each one is checked if the value is present in the filter map
              columnsWithFilter.forEach((col, columnId) => {
                const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

                // Update the filter state for each column
                handleFilterChange(columnId, newValue);
              });
            }}
            actions={
              selectOrders
                ? [
                    {
                      tooltip: "Start Quote",
                      icon: () => (
                        <Button variant="primary" size="small">
                          Start Quote
                        </Button>
                      ),
                      onClick: (evt, data) => {
                        log(data);
                        const reqObject = {
                          startQuoteMachineDTOList: data,
                        };
                        let validationResult = validateSelection(data);

                        if (validationResult === validationStatus.TRUE) {
                          setselectedMachinesForQuote(data);
                          handleOpen();
                        } else if (
                          validationResult === validationStatus.ERROR
                        ) {
                          toast.error(
                            "All selected orders should have/not have provider to start quote"
                          );
                        } else if (validateProvider(data)) {
                          setselectedMachinesForQuote(data);
                          setPreSelectedProvider(data[0].fullProviderList);
                          handleOpen();
                        } else {
                          toast.error(
                            "Invalid provider in selection, Please make sure selected orders have same provider"
                          );
                        }
                      },
                    },
                  ]
                : []
            }
          />
          <InternalQuoteDialog
            open={open}
            handleClose={handleClose}
            selectedMachineForQuote={selectedMachinesForQuote}
            getTableData={getTableData}
            preSelectedProvider={preSelectedProvider}
          />
        </div>
      )}
    </ThemeProvider>
  );
};

export default OrdersMaterialTable;
